<template>
    <custom-modal title="Upload Certificate" v-model="show" @close="close()" :loading="loading" :width="640">
        <div v-if="assignment" class="pa-2">
            <div class="text-subtitle-1 font-weight-medium">{{ assignment.training.title }}</div>
            <div class="caption grey--text text--darken-1 mb-3" v-if="assignment.training.provider">{{ assignment.training.provider }}</div>

            <v-alert v-if="assignment.status == 'rejected' && assignment.review_remarks" type="error" dense text class="mb-4">
                Previous certificate was rejected: {{ assignment.review_remarks }}
            </v-alert>

            <v-file-input
                v-model="file"
                label="Certificate (PDF or image)"
                accept=".pdf,image/*"
                prepend-icon="mdi-paperclip"
                outlined
                dense
                show-size
                :error-messages="fileError"
                @change="onFileChange"
            ></v-file-input>

            <div class="caption grey--text text--darken-1 mb-1">Date completed</div>
            <date-picker
                v-model="form.completed_on"
                type="date"
                value-type="YYYY-MM-DD"
                format="DD-MM-YYYY"
                :disabled-date="isFutureDate"
                style="width: 100%"
                class="mb-4"
            ></date-picker>

            <v-textarea v-model="form.staff_remarks" label="Remarks (optional)" outlined dense rows="2" auto-grow hide-details></v-textarea>
        </div>

        <template #actions>
            <v-btn small outlined color="blue" :disabled="!isFilled" :loading="loading" @click="save">submit</v-btn>
        </template>
    </custom-modal>
</template>

<script>
import CustomModal from '../util/CustomModal.vue'
import { MAX_CERTIFICATE_MB } from './trainingStatus'

export default {
    components: { CustomModal },
    data: () => ({
        show: false,
        loading: false,
        assignment: null,
        file: null,
        fileError: '',
        form: {
            completed_on: null,
            staff_remarks: '',
        },
    }),
    computed: {
        isFilled() {
            return this.file && !this.fileError && this.form.completed_on
        },
    },
    methods: {
        open(assignment) {
            this.assignment = assignment
            this.form.completed_on = assignment.completed_on
            this.form.staff_remarks = assignment.staff_remarks || ''
            this.show = true
        },
        isFutureDate(date) {
            return date > new Date()
        },
        onFileChange(file) {
            this.fileError = file && file.size > MAX_CERTIFICATE_MB * 1024 * 1024
                ? `File must be smaller than ${MAX_CERTIFICATE_MB} MB.`
                : ''
        },
        async save() {
            this.loading = true
            try {
                const formData = new FormData()
                formData.append('file', this.file)
                const uploadResp = await this.$axios.post('/api/uploads/training_certificates/', formData)

                await this.$axios.post(`/api/staff-training/my/${this.assignment.id}/submit`, {
                    file_id: uploadResp.data.data.id,
                    ...this.form,
                })
                this.$emit('saved')
                this.close()
            } catch (err) {
                // errors are toasted by the axios interceptor
            } finally {
                this.loading = false
            }
        },
        close() {
            Object.assign(this.$data, this.$options.data())
        },
    },
}
</script>
